import PackagesTableMobile from './PackagesTableMobile';

export default PackagesTableMobile;



// WEBPACK FOOTER //
// ./src/components/molecules/PackagesTableMobile/index.js